import { Checkbox, Control, Rectangle, Slider, StackPanel } from '@babylonjs/gui';
import { Game } from './Game';
import { GameState } from './GameState';
import { Gui } from './gui/Gui';

export class GameSettings {
  constructor(public game: Game) {}

  async create() {
    await Gui.createDefaultScene(
      this.game,
      {
        url: 'assets/skybox/space_laser.png',
        rotationAxis: 'y',
      },
      'Settings'
    );
    await Gui.createBackButton(this.game, GameState.MAIN, '🔙');
    await this.game.sound.createBackgroundMusic('erokia');

    interface SettingItem {
      label: string;
      type: 'checkbox' | 'slider';
      value: boolean | number;
      action: (v: any) => void;
    }

    const settings: SettingItem[] = [
      {
        label: 'Enable Music',
        type: 'checkbox',
        value: this.game.user.settings.enableMusic,
        action: (v: boolean) => {
          this.game.sound.play('click');
          this.game.user.settings.enableMusic = v;
          this.game.user.save();
          if (!v) this.game.sound.stopBackgroundMusic();
        },
      },
      {
        label: 'Enable Sound',
        type: 'checkbox',
        value: this.game.user.settings.enableSound,
        action: (v: boolean) => {
          this.game.sound.play('click');
          this.game.user.settings.enableSound = v;
          this.game.user.save();
        },
      },
      {
        label: 'Enable Speech',
        type: 'checkbox',
        value: this.game.user.settings.enableSpeech,
        action: (v: boolean) => {
          this.game.sound.play('click');
          this.game.user.settings.enableSpeech = v;
          this.game.user.save();
        },
      },
      {
        label: 'Music Volume',
        type: 'slider',
        value: this.game.user.settings.volumeMusic,
        action: (v: number) => {
          this.game.user.settings.volumeMusic = v;
          this.game.user.save();
        },
      },
      {
        label: 'Sound Volume',
        type: 'slider',
        value: this.game.user.settings.volumeSound,
        action: (v: number) => {
          this.game.user.settings.volumeSound = v;
          this.game.user.save();
        },
      },
      {
        label: 'Speech Volume',
        type: 'slider',
        value: this.game.user.settings.volumeSpeech,
        action: (v: number) => {
          this.game.user.settings.volumeSpeech = v;
          this.game.user.save();
        },
      },
    ];

    const grid = this.game.gui2D.createGrid('settings_grid', '80%', '60%', settings.length, 2, 0, (grid, r, c, i) => {
      const item = settings[r];
      if (c === 0) {
        const label = this.game.gui2D.createTextBlock('lbl_' + item.label, item.label, undefined, '50%');
        label.color = Gui.primaryColor.toHexString();
        label.textHorizontalAlignment = Control.HORIZONTAL_ALIGNMENT_RIGHT;
        label.textVerticalAlignment = Control.VERTICAL_ALIGNMENT_CENTER;
        label.width = '90%';
        return label;
      } else {
        const panel = new StackPanel('');
        panel.isVertical = false;
        panel.width = '100%';
        panel.height = '100%';

        // Spacer
        const spacer = new Rectangle();
        spacer.width = '5%';
        spacer.thickness = 0;
        panel.addControl(spacer);

        const inputHeight = '25px';
        if (item.type === 'checkbox') {
          const checkbox = new Checkbox();
          checkbox.width = inputHeight;
          checkbox.height = inputHeight;
          checkbox.isChecked = item.value as boolean;
          checkbox.color = Gui.secondaryColor.toHexString();
          checkbox.onIsCheckedChangedObservable.add((v) => item.action(v));
          panel.addControl(checkbox);
        } else if (item.type === 'slider') {
          const slider = new Slider();
          slider.minimum = 0;
          slider.maximum = 100;
          slider.value = (item.value as number) * 100;
          slider.width = '50%';
          slider.height = inputHeight;
          slider.color = Gui.secondaryColor.toHexString();
          slider.isThumbClamped = true;
          slider.isPointerBlocker = true;

          slider.onValueChangedObservable.add((v) => {
            item.action(v / 100);
            valueText.text = Math.round(v) + '%';
          });
          panel.addControl(slider);

          const valueText = this.game.gui2D.createTextBlock(
            '',
            Math.round((item.value as number) * 100) + '%',
            undefined,
            Gui.fontSizeXXXL
          );
          valueText.width = '20%';
          valueText.paddingLeft = '5%';
          valueText.isHitTestVisible = false;
          panel.addControl(valueText);
        }
        return panel;
      }
    });
    grid.top = '15%';
  }
}
